import React, { FC } from "react";

interface PreAuthorizationProps {
  children: React.ReactElement;
}

const PreAuthorization: FC<PreAuthorizationProps> = (props) => {
  const { pathname, search } = window.location;

  // Clear any existing tokens from embedded mode before starting OneLogin flow
  // This prevents using stale tokens from a previous embedded auth session
  localStorage.removeItem("accessToken");
  localStorage.removeItem("idToken");

  if (pathname && pathname !== "/") {
    localStorage.setItem("auth-redirect", JSON.stringify({ pathname, search }));
  }

  return props.children;
};

export default PreAuthorization;
